import { compact } from 'lodash';

import { SelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { AccessParameterFrequency, BeneficiaryLevel } from '@/types/schema';

export const ACCESS_PARAMETER_FREQUENCY_DISPLAY_NAMES: Record<
  AccessParameterFrequency,
  string
> = {
  [AccessParameterFrequency.Monthly]: 'Monthly',
  [AccessParameterFrequency.Quarterly]: 'Quarterly',
  [AccessParameterFrequency.Semiannually]: 'Semiannually',
  [AccessParameterFrequency.Annually]: 'Annually',
};

export const ACCESS_PARAMETER_FREQUENCY_ITEMS: SelectInputOption<AccessParameterFrequency>[] =
  [
    AccessParameterFrequency.Annually,
    AccessParameterFrequency.Semiannually,
    AccessParameterFrequency.Quarterly,
    AccessParameterFrequency.Monthly,
  ].map((value) => ({
    display: ACCESS_PARAMETER_FREQUENCY_DISPLAY_NAMES[value],
    value,
  }));

export const BENEFICIARY_LEVEL_CURRENT_ACCESS_DISPLAY_NAMES: Record<
  BeneficiaryLevel,
  string | null
> = {
  [BeneficiaryLevel.Primary]: 'Primary',
  [BeneficiaryLevel.Secondary]: 'Secondary',
  [BeneficiaryLevel.Tertiary]: 'Contingent',
  [BeneficiaryLevel.Other]: null,
};

export const BENEFICIARY_LEVELS: BeneficiaryLevel[] = [
  BeneficiaryLevel.Primary,
  BeneficiaryLevel.Secondary,
  BeneficiaryLevel.Tertiary,
  BeneficiaryLevel.Other,
];

export const BENEFICIARY_LEVEL_ITEMS: SelectInputOption<BeneficiaryLevel>[] =
  compact(
    [
      BeneficiaryLevel.Primary,
      BeneficiaryLevel.Secondary,
      BeneficiaryLevel.Tertiary,
      BeneficiaryLevel.Other,
    ].map((value) => {
      const display = BENEFICIARY_LEVEL_CURRENT_ACCESS_DISPLAY_NAMES[value];
      if (!display) return null;
      return {
        display,
        value,
      };
    })
  );
